import { useState, useEffect } from "react";
import { Box, Button, Tooltip, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseOrdersReport } from "./UseOrdersReport";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import RefreshIcon from "@mui/icons-material/Refresh";
import AssessmentIcon from "@mui/icons-material/Assessment";
import moment from "jalali-moment";
import ProgressCom from "../../components/ProgressCom";
import MYGrid from "./MYGrid";
import DownloadIcon from "@mui/icons-material/Download";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";

export default function OrdersReport(props) {
  const location = useLocation();
  var NewDate = new Date();
  // let persianDate = moment(NewDate).locale("fa").format("DD");
  let persianMonth = moment(NewDate).locale("fa").format("MM");
  let persianYear = moment(NewDate).locale("fa").format("YYYY");
  // const [search, setSearch] = useState(
  //   location.state && location.state.search ? location.state.search : ""
  // );
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetDailyReport, UpdateDailyReport, ExportList } = UseOrdersReport();
  const navigate = useNavigate();
  const { myPc, updatePage, updateSort } = UseMyPC("ShamsiOrderDate", "Desc");
  const [dailyReport, setDailyReport] = useState();
  const [monthReport, setMonthReport] = useState(
    location.state && location.state.monthReport
      ? location.state.monthReport
      : persianMonth
  );
  const [yearReport, setYearReport] = useState(
    location.state && location.state.yearReport
      ? location.state.yearReport
      : persianYear
  );
  const [reportState, setReportState] = useState(
    location.state && location.state.reportState
      ? location.state.reportState
      : "month"
  );
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  useEffect(() => {
    // if (
    //   myPc.page === 0 ||
    //   (location.state && location.state && location.state.isBack)
    // ) {
    //   return;
    // }
    // var NewDate = new Date();
    // let persianDate = moment(NewDate).locale("fa").format("DD");
    // let persianMonth = moment(NewDate).locale("fa").format("MM");
    // let persianYear = moment(NewDate).locale("fa").format("YYYY");
    // setMonthReport(persianMonth);
    // setYearReport(persianYear);
    setProgress(true);
    GetDailyReport(yearReport, monthReport, myPc, true, (callback) => {
      setDailyReport(callback);
    });
  }, [myPc, yearReport, monthReport]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "orderRow",
      width: 80,
      align: "center",
      headerName: "روز",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "shamsiOrderDate",
      headerName: "تاریخ",
      width: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "orderCount",
      headerName: "تعداد",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalPaycost",
      headerName: "مجموع پرداختی",
      width: 160,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalDiscount",
      headerName: "تخفیف",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "deliverycost",
      headerName: "هزینه ارسال",
      width: 130,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "عملیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="refresh">
              <IconButton
                onClick={() => {
                  var update = {
                    OrderDate: cellValues.row.orderdate.split("T")[0],
                  };
                  setProgress(true);
                  UpdateDailyReport(update, (callbacks) => {
                    GetDailyReport(
                      yearReport,
                      monthReport,
                      myPc,
                      true,
                      (callback) => {
                        setDailyReport(callback);
                      }
                    );
                  });
                }}
              >
                <RefreshIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="details">
              <IconButton
                onClick={() => {
                  return navigate("/ordersreport/OrderReportDetails", {
                    state: {
                      name: "روزانه",
                      ReportName: cellValues.row.shamsiOrderDate,
                      startDate: cellValues.row.startDate,
                      endDate: cellValues.row.endDate,
                      yearReport: yearReport,
                      monthReport: monthReport,
                      reportState: reportState,
                    },
                  });
                }}
              >
                <AssessmentIcon
                  fontSize="small"
                  sx={{ color: "MyColor.main" }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="excel">
              <IconButton
                onClick={() => {
                  setCheckState({
                    show: true,
                    name: "دانلود اکسل",
                    startDate: cellValues.row.startDate,
                    endDate: cellValues.row.endDate,
                  });
                }}
              >
                <DownloadIcon fontSize="small" sx={{ color: "primary.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/ordersreport" }],
      }}
    >
      <Box sx={{ height: "70%", mb: 5 }}>
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={
            dailyReport && dailyReport.pageCondition
              ? dailyReport.pageCondition.pageCount
              : 1
          }
          rows={dailyReport ? dailyReport.orders : []}
          paginationMode="server"
          page={
            dailyReport && dailyReport.pageCondition
              ? dailyReport.pageCondition.page - 1
              : 1
          }
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            dailyReport && dailyReport.pageCondition
              ? dailyReport.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              nofab: true,
              rowCount:
                dailyReport && dailyReport.pageCondition
                  ? dailyReport.pageCondition.totalItemCount
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      </Box>
      <Box sx={{ height: "90%", pb: "20px" }}>
        <MYGrid
          monthReport={monthReport}
          reportState={reportState}
          setReportState={setReportState}
          yearReport={yearReport}
          setMonthReport={setMonthReport}
          setYearReport={setYearReport}
        />
      </Box>
      {!dailyReport && <ProgressCom></ProgressCom>}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let state = {
            startDate: checkState.startDate,
            endDate: checkState.endDate,
          };
          setProgress(true);
          ExportList(state.startDate, state.endDate, (res) => {
            window.open(res, "_blank");
            console.log(res);
          });
        }}
      />
    </Detail>
  );
}
